import styled, { css } from 'styled-components';

export const TopicCard = styled.div`
  width: 100%;
  padding: 32px;
  border-radius: 16px;
  margin-bottom: 24px;
  background: ${(props) => props.theme.colors['neutral-10']};
  filter: drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.07));
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 27px;
  justify-content: space-between;
`;

export const TopicTitle = styled.p`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 16px;
  line-height: 18px;
  font-weight: 600;
  margin-right: 12px;
`;

export const AddNewNoteButton = styled.button`
  color: ${(props) => props.theme.colors['primary-60']};
  font-size: 14px;
  line-height: 21px;
`;
